import { IRootState } from '../reducers/rootReducer'
import { IAccountReducer } from '../reducers/accountReducer'

export const getAccount = (state: IRootState): IAccountReducer => {
	return state.account
}
